"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const transactions_1 = require("companion-app-components/flux/transactions");
const mui_1 = require("tss-react/mui");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.transactionLabelStyles);
const getTxnTypeClasses = (type, classes) => {
    switch (type) {
        case transactions_1.transactionsTypes.calTxnLabelTypes.more:
            return classes.moreType;
        case transactions_1.transactionsTypes.calTxnLabelTypes.income:
            return classes.dueType;
        case transactions_1.transactionsTypes.calTxnLabelTypes.expense:
            return classes.dueType;
        case transactions_1.transactionsTypes.calTxnLabelTypes.overdue:
            return classes.overdueType;
        case transactions_1.transactionsTypes.calTxnLabelTypes.normal:
        default:
            return null; // classes.normalType
    }
};
const TxnBubble = ({ txn }) => {
    const { classes, cx } = useStyles();
    const typeClasses = (0, react_1.useMemo)(() => getTxnTypeClasses(txn.type, classes), [txn, classes]);
    return (<div key={txn.id} className={cx(classes.label, { [typeClasses]: Boolean(typeClasses) }, txn.isIncome ? classes.incomeType : classes.expenseType)}/>);
};
exports.default = (0, react_1.memo)(TxnBubble);
